import { Component, input, OnDestroy, OnInit } from '@angular/core';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatButton } from '@angular/material/button';
import { Address, Lead } from '../../../../lead.model';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { GeolocationService } from '../../../../services/geolocation/geolocation.service';
import { DialogService } from '../../../../services/dialog/dialog.service';
import { LeadDashboardService } from '../../../lead-dashboard.service';
import { RouteInformationService } from '../../../route-information.service';
import { CompressedOpeningTimes } from '../../../../reusable-components/compressed-opening-times';
import { Unsubscribable } from 'rxjs';

@Component({
  selector: 'app-mat-extension-panel-lead',
  imports: [
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatButton,
    AsyncPipe,
    MatExpansionPanelHeader,
    TranslatePipe,
  ],
  templateUrl: './mat-extension-panel-lead.component.html',
  styleUrl: './mat-extension-panel-lead.component.scss',
})
export class MatExtensionPanelLeadComponent implements OnInit, OnDestroy {
  lead = input.required<Lead>();
  number = input.required<number>();

  compressedOpeningTimes = '';
  compressedOpeningTimesSubscription: Unsubscribable | undefined;

  constructor(
    private readonly dialogService: DialogService,
    private readonly geolocationService: GeolocationService,
    private readonly leadDashboardService: LeadDashboardService,
    public routeInformationService: RouteInformationService,
    private readonly translateService: TranslateService,
  ) {}

  gotoLeadDetail(lead: Lead): void {
    this.leadDashboardService.startLeadExamination(lead);
  }

  addressToString(address: Address): string {
    const streetPart =
      `${address.street || ''} ${address.houseNumber || ''}`.trim();
    return `${streetPart}${streetPart ? ', ' : ''}${address.postalCode} ${address.city}`;
  }

  openGoogleMaps(lead: Lead) {
    const address = encodeURI(this.addressToString(lead.address));
    const url = `https://www.google.com/maps/search/?api=1&query=${address}`;
    window.open(url, '_blank');
  }

  ngOnDestroy(): void {
    this.compressedOpeningTimesSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    const compressedOpeningTimes = new CompressedOpeningTimes(
      this.translateService,
      this.lead().openingTimes || { openingDays: [] },
    );
    this.compressedOpeningTimesSubscription = compressedOpeningTimes.subscribe(
      (newCompressedOpeningTimes: string) =>
        (this.compressedOpeningTimes = newCompressedOpeningTimes),
    );
  }
}
